export default __webpack_public_path__ + "static/meshery_cb_load_test-543e3861787517cc87ab1ddb026ee07f.webp";